
<div class="accountSummaryDiv">

  <div class="row">
    <!--<div class="col-sm-12 col-md-12 headerText">
      <h2>  Account Summary</h2>
    </div>
    <br/>
    <br/>-->
    <div class="col-12">
      <h4> {{accountSummaryLbl.billingAddressLbl?accountSummaryLbl.billingAddressLbl:accountSummaryPage.billingAddressLbl}}</h4>

      <label class="lblCls">
        {{customerName}}

      </label>
      <br />
      <label class="lblCls">
        {{billingAddress}}
      </label>
    </div>

    <div class="col-sm-12 col-md-3">
      <div class="form-group">
        <label class="lblCls">
          {{accountSummaryLbl.amountDueLbl?accountSummaryLbl.amountDueLbl:accountSummaryPage.amountDueLbl}}
        </label>
        <input type="text" class="form-control" value="{{accountSummary.amountDue|currency}}" readonly />

      </div>
      <div class="form-group">
        <label class="lblCls">
          {{accountSummaryLbl.totalExposureLbl?accountSummaryLbl.totalExposureLbl:accountSummaryPage.totalExposureLbl}}
        </label>
        <input type="text" class="form-control" value="{{accountSummary.totalExposure|currency}}" readonly />
      </div>

      <div class="form-group">
        <label class="lblCls">
          {{accountSummaryLbl.overCreditLmtLbl?accountSummaryLbl.overCreditLmtLbl:accountSummaryPage.overCreditLmtLbl}}
        </label>
        <input type="text" class="form-control" value="{{accountSummary.overCreditLimit|currency}}" readonly />
      </div>
      <div class="form-group">
        <label class="lblCls">
          {{accountSummaryLbl.lastInvoiceDateLbl?accountSummaryLbl.lastInvoiceDateLbl:accountSummaryPage.lastInvoiceDateLbl}}
        </label>
        <input type="text" class="form-control" [(ngModel)]="accountSummary.lastInvoiceDate" readonly />
      </div>
      <!--<div class="form-group">
        <label class="lblCls">
          {{accountSummaryLbl.paymentTermsLbl?accountSummaryLbl.paymentTermsLbl:accountSummaryPage.paymentTermsLbl}}
        </label>
        <input type="text" class="form-control" [(ngModel)]="accountSummary.paymentTerms" readonly />
      </div>-->


    </div>
    <div class="col-sm-12 col-md-3">

      <div class="form-group">
        <label class="lblCls">
          {{accountSummaryLbl.openOrderAmtLbl?accountSummaryLbl.openOrderAmtLbl:accountSummaryPage.openOrderAmtLbl}}
        </label>
        <input type="text" class="form-control" value="{{accountSummary.openOrderAmount|currency}}" readonly />
      </div>
      <div class="form-group">
        <label class="lblCls">
          {{accountSummaryLbl.creditLmtLbl?accountSummaryLbl.creditLmtLbl:accountSummaryPage.creditLmtLbl}}
        </label>
        <input type="text" class="form-control" value="{{accountSummary.creditLimit|currency}}" readonly />
      </div>


      <div class="form-group">
        <label class="lblCls">
          {{accountSummaryLbl.dofInvoiceLbl?accountSummaryLbl.dofInvoiceLbl:accountSummaryPage.dofInvoiceLbl}}
        </label>
        <input type="text" class="form-control" [(ngModel)]="accountSummary.dateOfFirstInvoice" readonly />
      </div>

      <div class="form-group">
        <label class="lblCls">
          {{accountSummaryLbl.dateLastPaidLbl?accountSummaryLbl.dateLastPaidLbl:accountSummaryPage.dateLastPaidLbl}}
        </label>
        <input type="text" class="form-control" [(ngModel)]="accountSummary.dateLastPaid" readonly />
      </div>

    </div>
  </div>

</div>
